import React from "react";
import "./Loader.scss"; 

const Loader = () => {
  return (
      <div className="dot-loader" >
        <span></span>
        <span></span>
        <span></span>
      </div>
    )
};

export default Loader;
